import React from 'react';
import styled from 'styled-components';
import { Box, Flex } from 'pcln-design-system';
import BannerWrapper from './BannerWrapper';
import IconRightContainer from './IconRightContainer';
import BoxToFlex from './BoxToFlex';
const FullWidthButtonContainer = styled(Box) `
  ${({ buttonRightBreakPoint, theme }) => `
  display: block;
  ${theme.mediaQueries[buttonRightBreakPoint]} {
    display: none;
  }
`}
`;
const PartialWidthButtonContainer = styled(Flex) `
  ${({ buttonRightBreakPoint, isButtonFullWidthAtBreakPoint, theme }) => `
    ${isButtonFullWidthAtBreakPoint &&
    `
      display: none;
      ${theme.mediaQueries[buttonRightBreakPoint]} {
        display: flex;
      }
  `}
`}
`;
/** @public */
const Banner = ({ badge, bgColor, borderHugLeft, borderHugTop, borderRadius = 'xl', boxShadowSize, buttonRight, buttonRightBreakPoint, flexPadding = [1, null, 2], heading, hoverBoxShadowSize, iconLeft, iconRight, imageLeft, isButtonFullWidthAtBreakPoint = false, justifyContent = 'space-between', outline, px = 2, py = 2, text, }) => {
    const hasLeftContent = !!imageLeft || !!iconLeft;
    return (React.createElement(BannerWrapper, { "data-testid": 'bannerWrapper', bgColor: bgColor, borderHugLeft: borderHugLeft, borderHugTop: borderHugTop, borderRadius: borderRadius, boxShadowSize: boxShadowSize, hoverBoxShadowSize: hoverBoxShadowSize, outline: outline, px: px, py: py },
        React.createElement(Flex, { justifyContent: 'center', alignItems: 'center', p: flexPadding },
            !!imageLeft && imageLeft,
            !!iconLeft && iconLeft,
            React.createElement(BoxToFlex, { alignItems: 'center', buttonRightBreakPoint: buttonRightBreakPoint, "data-testid": 'bannerContents', isButtonFullWidthAtBreakPoint: isButtonFullWidthAtBreakPoint, justifyContent: justifyContent, width: 1 },
                React.createElement(Box, { mx: [1, null, 0], pl: hasLeftContent ? [1, null, 3] : undefined },
                    !!badge && badge,
                    !!heading && heading,
                    !!text && text),
                buttonRight && (React.createElement(PartialWidthButtonContainer, { "data-testid": 'buttonBox', buttonRightBreakPoint: buttonRightBreakPoint, isButtonFullWidthAtBreakPoint: isButtonFullWidthAtBreakPoint, justifyContent: justifyContent === 'center' ? 'center' : 'flex-start', ml: justifyContent === 'space-between' ? 'auto' : undefined, pl: hasLeftContent ? [2, null, 3] : undefined, pr: 1 }, buttonRight)))),
        buttonRight && isButtonFullWidthAtBreakPoint && (React.createElement(FullWidthButtonContainer, { "data-testid": 'buttonBoxFullWidth', buttonRightBreakPoint: buttonRightBreakPoint, px: imageLeft ? 0 : 1, py: 1, width: 1 }, buttonRight)),
        iconRight && React.createElement(IconRightContainer, null, iconRight)));
};
export default Banner;
//# sourceMappingURL=Banner.js.map